import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    status: "not-authenticated", // 'not-authenticated' | 'authenticated' | 'checking'
    id: null,
    username: null,
    token: null,
    nombre: null,
    apellido: null,
    error: null,
    telefono_informacion: null,
    telefono: null,
    email_informacion: null,
    idClienteFlota: null,
    flotas: null,
    controlKmFlota: null,
  },
  reducers: {
    login: (state, action) => {
      state.status = "authenticated";
      state.id = action.payload.id;
      state.username = action.payload.username;
      state.token = action.payload.token;
      state.nombre = action.payload.nombre;
      state.apellido = action.payload.apellido;
      state.error = null;
      state.telefono_informacion = action.payload.telefono_informacion;
      state.telefono = action.payload.telefono;
      state.email_informacion = action.payload.email_informacion;
      state.flotas = action.payload.flotas;
      state.controlKmFlota = action.payload.flotaActiva?.km;
    },
    logout: (state, action) => {
      state.status = "not-authenticated";
      state.id = null;
      state.username = null;
      state.token = null;
      state.nombre = null;
      state.apellido = null;
      state.error = action.payload.error;
      state.telefono_informacion = null;
      state.telefono = null;
      state.email_informacion = null;
      state.flotas = null;
      state.controlKmFlota = null;
    },
    checkingCredentials: (state, action) => {
      state.status = "checking";
      state.error = null;
    },
    updateDataClient: (state, action) => {
      state.nombre = action.payload.nombre;
      state.apellido = action.payload.apellido;
      state.telefono = action.payload.telefono;
    },
    changeFlotaActiva: (state, action) => {
      state.flotaActiva = action.payload;
      state.controlKmFlota = action.payload.km;
    },
    changeCuentas: (state, action) => {
      state.cuentas = action.payload;
    },
    changeKm: (state, action) => {
      state.controlKmFlota = action.payload === true ? 1 : 0;
    },
    setFlotaId: (state, action) => {
      state.idClienteFlota = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  login,
  logout,
  checkingCredentials,
  updateDataClient,
  changeFlotaActiva,
  changeCuentas,
  changeKm,
  setFlotaId,
} = authSlice.actions;
